import React,{useState, useEffect}  from 'react';
import Card from 'react-bootstrap/Card';
import Sides from '../Bars/Csharpsidebar';
import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";
function Csmultilevel(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  
return(
    <div>
      <Sides/>
      <Helmet>
 
 <title>C# Multilevel inheritance tutorial For Beginners</title>
 <meta name="description" content="C# Multilevel inheritance tutorial for beginners.CodeExampler provides Multiple Programming Examples for Beginners,CodeExampler provides Free Online Tutorials for beginners" />
 <meta name="keywords" content="codeexampler,programming language,tutorial for begineers,C# Multilevel inheritance,c# Multilevel inheritance for,c sharp Multilevel inheritance,c# Multilevel inheritance for loop,Multilevel inheritance Example in Csharp(C#)" />
 <link rel="canonical" href="https://www.codeexampler.com/csharp-multilevel-inheritance" />
 </Helmet>

 <div className='lg:pl-56'>
    <h1 className="m-4 mh1">Multilevel inheritance in c#</h1>
    <div className="first">
        <a href="/csharp-single-inheritance">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/csharp-association">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>




      <h2 className='headings'>Q-Write a Program and call Method Example of Multilevel Inheritance in C# ?</h2>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"500vh"}}>
           <code >
             {"\n"}
                 <span className="qwerty">class</span>
                 <span className="qwerty-4"> multilevel_inheritance</span>
                 {"\n"}
                 <span className="qwerty-1">&#123;</span>
                 {"\n"}
                 <span className="qwerty-4"> void </span>
                 <span className="qwerty-2">a</span>
                 <span className="qwerty-1">()</span>
                 {"\n"}
                 <span className="qwerty-1"> &#123;</span>
                 {"\n"}
                 <span className="qwerty-7">  Console.WriteLine</span>
                 <span className="qwerty-1">("</span>
                 <span className="qwerty-10">This is </span>
                 <span className="qwerty-3">a </span>
                 <span className="qwerty-10">class</span>
                 <span className="qwerty-1">");</span>
                 {"\n"}
                 <span className="qwerty-1"> &#125;</span>
                 {"\n"}
                 <span className="qwerty-1">&#125;</span>
                 {"\n"}
                 <span className="qwerty">class</span>
                 <span className="qwerty-8"> b</span>
                 <span className="qwerty-3"> extends</span>
                 <span className="qwerty-4"> a</span>
                 {"\n"}
                 <span className="qwerty-1">&#123;</span>
                 {"\n"}
                 <span className="qwerty-4"> void </span>
                 <span className="qwerty-8">b</span>
                 <span className="qwerty-1">()</span>
                 {"\n"}
                 <span className="qwerty-1"> &#123;</span>
                 {"\n"}
                 <span className="qwerty-7">  Console.WriteLine</span>
                 <span className="qwerty-1">("</span>
                 <span className="qwerty-10">This is </span>
                 <span className="qwerty-3">b </span>
                 <span className="qwerty-10">class</span>
                 <span className="qwerty-1">");</span>
                 {"\n"}
                 <span className="qwerty-1"> &#125;</span>
                 {"\n"}
                 
                 <span className="qwerty">class</span>
                 <span className="qwerty-4"> c</span>
                 <span className="qwerty-3"> extends</span>
                 <span className="qwerty-8"> b</span>
                 {"\n"}
                 <span className="qwerty-1">&#123;</span>
                 {"\n"}
                 <span className="qwerty-4"> void </span>
                 <span className="qwerty-4">c</span>
                 <span className="qwerty-1">()</span>
                 {"\n"}
                 <span className="qwerty-1"> &#123;</span>
                 {"\n"}
                 <span className="qwerty-7">  Console.WriteLine</span>
                 <span className="qwerty-1">("</span>
                 <span className="qwerty-10">This is </span>
                 <span className="qwerty-3">c </span>
                 <span className="qwerty-10">class</span>
                 <span className="qwerty-1">");</span>
                 {"\n"}
                 <span className="qwerty-1"> &#125;</span>
                 {"\n"}
                 
                 <span className="qwerty-6"> public </span>
                 <span className="qwerty-1">static </span>
                 <span className="qwerty-4">void </span>
                 <span className="qwerty-2">main</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-4">String</span>
                 <span className="qwerty-1">[]</span>
                 <span className="qwerty-3">args</span>
                 <span className="qwerty-1">)</span>
                 {"\n"}
                 <span className="qwerty-1"> &#123;</span>
                 {"\n"}
                 <span className="qwerty">  c</span>
                 <span className="qwerty-8"> all</span>
                 <span className="qwerty-1"> = </span>
                 <span className="qwerty-3">new</span>
                 <span className="qwerty-2"> c</span>
                 <span className="qwerty-1">();</span>
                 {"\n"}
                 <span className="qwerty-8">  all</span>
                 <span className="qwerty-1">.</span>
                 <span className="qwerty-4">a</span>
                 <span className="qwerty-1">();</span>
                 {"\n"}
                 <span className="qwerty-8">  all</span>
                 <span className="qwerty-1">.</span>
                 <span className="qwerty-5">b</span>
                 <span className="qwerty-1">();</span>
                 {"\n"}
                 <span className="qwerty-8">  all</span>
                 <span className="qwerty-1">.</span>
                 <span className="qwerty-6">c</span>
                 <span className="qwerty-1">();</span>
                 {"\n"}
                 <span className="qwerty-1"> &#125;</span>
                 {"\n"}
                 <span className="qwerty-1">&#125;</span>
             {"\n"}{"\n"}
                  </code>
         </pre>
         </div>
         <h5 className='headings'> Output : </h5>
           <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
              <pre style={{maxHeight:"500vh"}}>
                  <code >
                      {"\n"}
                          <span className="qwerty-9">This is </span>
                          <span className="qwerty-6">a </span>
                          <span className="qwerty-9">class</span>
                          {"\n"} 
                          <span className="qwerty-9">This is </span>
                          <span className="qwerty-6">b </span>
                          <span className="qwerty-9">class</span>
                          {"\n"}      
                          <span className="qwerty-9">This is </span>
                          <span className="qwerty-6">c </span>
                          <span className="qwerty-9">students</span>
                          {"\n"}      
                          {"\n"}      
                </code>
                  </pre>
                  </div>

  <h1 className="mt-5">  </h1>
     
  <div className="back">
        <a href="/csharp-single-inheritance">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/csharp-association">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
        </div>
    </div>
)

}
export default Csmultilevel;